<p class="m-0">
  <strong>{{ 'header.search.sectionsTitles.topProducts' | i18next }}</strong>
</p>

<div class="products-btn-container" *ngIf="suggestions$ | async as suggestions; else noMatches">
  <shrd-uic-nav-button
    *ngFor="let product of suggestions.products; last as isLast; trackBy: trackById"
    class="suggested-products-nav-btn mt-1"
    [ngClass]="{ 'mb-1': isLast }"
    [imgUrl]="product.thumbnail"
    [isCompressed]="true"
    [url]="'/' + product.id"
    [usePlaceholder]="true"
    [shrdUtcTrackEvent]="{
      category: 'ProductInfo',
      action: 'FindProducts',
      label: 'SiteSearchAutoSuggest|' + suggestions.term + '|' + product.id
    }"
  >
    <span class="suggested-products-nav-btn-text truncate-2">
      <span [innerHTML]="product.title | highlightText : suggestions.term | suffixLabel : product"></span>
    </span>
  </shrd-uic-nav-button>
</div>

<ng-template #noMatches>
  <p class="m-0 mb-1 mb-md-0">{{ 'header.search.noMatches' | i18next }}</p>
</ng-template>
